import Result from "@/core/common/Result";

export interface IValidarCertificadoParams {
  file: string;
  senha: string;
}

export interface IValidarCertificadoResponse {
  empresaId: string;
  possiveisEmpresas: { id: string; nomeFantasia: string }[];
  mensagemDeErro: string;
}

export interface IInserirCertificadoParams {
  file: string;
  senha: string;
  empresasIds: string[];
}

export interface IAtualizarCertificadoGateway {
  validarCertificado(
    params: IValidarCertificadoParams
  ): Promise<Result<IValidarCertificadoResponse>>;
  inserirCertificado(params: IInserirCertificadoParams): Promise<Result<void>>;
}

export const AtualizarCertificadoGatewayDi = Symbol(
  "AtualizarCertificadoGatewayDi"
);
